module.exports = __webpack_public_path__ + "img/logo.e3c726ef.png";